var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChaticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.15,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#666687"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.53 10.008C12.9754 9.2321 13.6681 8.62793 14.4973 8.29207C15.3266 7.9562 16.2445 7.90804 17.1043 8.15527C17.9641 8.40251 18.7163 8.93086 19.2405 9.65588C19.7646 10.3809 20.0306 11.2607 19.9959 12.1547C19.9612 13.0487 19.6278 13.9053 19.0489 14.5875C18.4701 15.2697 17.6793 15.7381 16.8028 15.9179C15.9264 16.0977 15.015 15.9785 14.2143 15.5793C13.4136 15.1802 12.7699 14.5241 12.386 13.716C12.1294 13.9036 11.8198 14.0045 11.502 14.004H11.002V14.259C11.002 14.449 11.074 14.622 11.192 14.753C11.2928 14.639 11.426 14.5584 11.5737 14.522C11.7215 14.4856 11.8768 14.4951 12.0191 14.5491C12.1614 14.6032 12.2838 14.6994 12.37 14.8247C12.4563 14.9501 12.5023 15.0988 12.502 15.251C12.5019 15.3555 12.48 15.4589 12.4376 15.5544C12.3952 15.65 12.3334 15.7356 12.256 15.8058C12.1786 15.8761 12.0874 15.9294 11.9882 15.9623C11.889 15.9952 11.784 16.007 11.68 15.997C11.2296 15.9812 10.8029 15.7912 10.4899 15.4669C10.1769 15.1427 10.0019 14.7097 10.002 14.259V10.507C10.002 10.3744 10.0546 10.2472 10.1484 10.1534C10.2422 10.0597 10.3693 10.007 10.502 10.007H12.502L12.53 10.008ZM11.002 13.004H11.502C11.6346 13.004 11.7617 12.9513 11.8555 12.8576C11.9493 12.7638 12.002 12.6366 12.002 12.504V12.134C11.999 12.0447 11.999 11.9553 12.002 11.866V11.007H11.002V13.004Z",
    fill: "#666687"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 19C9 17.887 9.903 17 11.009 17H21C21.5304 17 22.0391 17.2107 22.4142 17.5858C22.7893 17.9609 23 18.4696 23 19C23 20.691 22.167 21.966 20.865 22.797C19.583 23.614 17.855 24 16 24C14.145 24 12.417 23.614 11.135 22.797C9.833 21.967 9 20.69 9 19Z",
    fill: "#666687"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChaticon);
export default __webpack_public_path__ + "static/media/Chaticon.604fc264fa2487a18d3140cde977725c.svg";
export { ForwardRef as ReactComponent };